import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick,
  type = 'button',
  disabled = false,
  isLoading = false,
  className = ''
}: ButtonProps) {
  const [ripples, setRipples] = useState<Array<{
    x: number;
    y: number;
    id: number;
  }>>([]);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick && !disabled && !isLoading) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const id = Date.now();
      setRipples([...ripples, {
        x,
        y,
        id
      }]);
      setTimeout(() => {
        setRipples(prev => prev.filter(ripple => ripple.id !== id));
      }, 600);
      onClick();
    }
  };
  const baseStyles = 'relative inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.97] overflow-hidden';
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-primary-600 shadow-soft hover:shadow-medium hover:-translate-y-0.5 focus-visible:ring-primary',
    secondary: 'bg-secondary text-white hover:bg-secondary-600 shadow-soft hover:shadow-medium hover:-translate-y-0.5 focus-visible:ring-secondary',
    outline: 'bg-transparent text-charcoal border-2 border-neutral-300 hover:border-primary hover:bg-primary/5 hover:text-primary focus-visible:ring-primary',
    ghost: 'bg-transparent text-charcoal hover:bg-neutral-100 hover:text-primary focus-visible:ring-primary',
    white: 'bg-white text-primary hover:bg-neutral-50 shadow-soft hover:shadow-medium hover:-translate-y-0.5 focus-visible:ring-white'
  };
  const sizeStyles = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-6 py-3.5 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  return <button type={type} onClick={handleClick} disabled={disabled || isLoading} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className}`} data-id="element-55">
      {/* Ripple effect */}
      {ripples.map(ripple => <span key={ripple.id} className="absolute bg-white/30 rounded-full pointer-events-none animate-ripple" style={{
      left: ripple.x,
      top: ripple.y,
      width: 10,
      height: 10,
      transform: 'translate(-50%, -50%)'
    }} data-id="element-56" />)}

      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-57" />}
      <span className="relative z-10" data-id="element-58">{children}</span>
    </button>;
}